import { useState } from 'react';
import styles from './DemoPage.module.scss';
import {
  AvatarSection,
  ButtonsSection,
  ColorsSection,
  ContactLinkSection,
  EmptyStatesSection,
  GenerateMoreModalSection,
  HeaderSection,
  IconButtonSection,
  IconsSection,
  InfoChipSection,
  InputOTPSection,
  InputsSection,
  LeadTypeHeaderSection,
  LogoSection,
  MenuSelectSection,
  ModalsSection,
  NumericStepperSection,
  PageHeaderSection,
  PagesSection,
  ProfileCardSection,
  sectionGroups,
  SegmentedControlSection,
  SelectableRowSection,
  SelectFilterSection,
  SSOButtonsSection,
  TableCellsSection,
  TabsSection,
  ThemeSwitcherSection,
  TooltipSection,
  TypeAheadSection,
  TypographySection,
  WhatsappCardSection,
  GifPreviewSection,
  type SectionId,
} from './sections';

// Map section IDs to their components
const sectionComponents: Record<SectionId, React.FC> = {
  pages: PagesSection,
  typography: TypographySection,
  colors: ColorsSection,
  avatar: AvatarSection,
  buttons: ButtonsSection,
  'contact-link': ContactLinkSection,
  inputs: InputsSection,
  tabs: TabsSection,
  icons: IconsSection,
  logo: LogoSection,
  header: HeaderSection,
  'icon-button': IconButtonSection,
  'info-chip': InfoChipSection,
  'empty-states': EmptyStatesSection,
  'page-header': PageHeaderSection,
  'profile-card': ProfileCardSection,
  'segmented-control': SegmentedControlSection,
  'selectable-row': SelectableRowSection,
  'select-filter': SelectFilterSection,
  'lead-type-header': LeadTypeHeaderSection,
  'menu-select': MenuSelectSection,
  modals: ModalsSection,
  'generate-more-modal': GenerateMoreModalSection,
  'sso-buttons': SSOButtonsSection,
  'table-cells': TableCellsSection,
  'input-otp': InputOTPSection,
  'numeric-stepper': NumericStepperSection,
  'theme-switcher': ThemeSwitcherSection,
  tooltip: TooltipSection,
  typeahead: TypeAheadSection,
  'whatsapp-card': WhatsappCardSection,
  'gif-preview': GifPreviewSection,
};

export const DemoPage = () => {
  const [activeSection, setActiveSection] = useState<SectionId>('pages');

  // Get the component for the active section
  const ActiveSectionComponent = sectionComponents[activeSection];

  return (
    <div className={styles.page}>
      {/* Sidebar Navigation */}
      <nav className={styles.sidebar}>
        <div className={styles.sidebarHeader}>
          <h1 className={styles.sidebarTitle}>Component Library</h1>
          <p className={styles.sidebarSubtitle}>Developer Guide</p>
        </div>
        <div className={styles.sidebarNav}>
          {sectionGroups.map((group, groupIndex) => (
            <div key={group.label} className={styles.sidebarGroup}>
              {groupIndex > 0 && <div className={styles.sidebarSeparator} />}
              <span className={styles.sidebarGroupLabel}>{group.label}</span>
              <ul className={styles.sidebarGroupItems}>
                {group.items.map((section) => (
                  <li key={section.id}>
                    <button
                      className={`${styles.sidebarLink} ${activeSection === section.id ? styles.sidebarLinkActive : ''}`}
                      onClick={() => setActiveSection(section.id as SectionId)}
                    >
                      {section.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </nav>

      {/* Main Content */}
      <main className={styles.main}>
        <ActiveSectionComponent />
      </main>
    </div>
  );
};
